import apiService from "services/apiService";
import { AxiosResponse } from "axios";
import { LeavePolicy, LeavePolicyPayload } from "./leavePolicyInterface";

/**
 * Leave Policy API access. Conventional REST over /api/leave-policies:
 * list (GET), create (POST), update (PUT /{id}), delete (DELETE /{id}).
 */
class LeavePolicyManager {
  private url: string;
  constructor() {
    this.url = `api/leave-policies`;
  }

  async getAll(): Promise<AxiosResponse<LeavePolicy[] | { content?: LeavePolicy[] }>> {
    return await apiService.get(this.url);
  }

  async create(payload: LeavePolicyPayload): Promise<AxiosResponse<LeavePolicy>> {
    return await apiService.post(this.url, payload);
  }

  async update(id: number, payload: LeavePolicyPayload): Promise<AxiosResponse<LeavePolicy>> {
    return await apiService.put(`${this.url}/${id}`, payload);
  }

  // DELETE /api/leave-policies/{id}?isActive=true
  async remove(id: number, isActive = true): Promise<AxiosResponse> {
    return await apiService.delete(`${this.url}/${id}?isActive=${isActive}`);
  }
}

const leavePolicyManager = new LeavePolicyManager();
export default leavePolicyManager;
